// Components==============
import React from 'react';
import { useSelector } from 'react-redux';
import CheatSheetBox from './CheatSheetBox/CheatSheetBox';
import CheatSheetPlayer from './CheatSheetPlayer/CheatSheetPlayer';

// =========================

export default function Front({
    setVideo,
}: {
    setVideo: (videoIdProp: string) => void;
}) {
    const treatmentsForVideo = useSelector(
        (state: ReduxStore) =>
            state.authentication?.user?.progress?.treatments || []
    );

    return (
        <>
            <CheatSheetBox text="Weetwoorden">
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('e84a2b35f9adb29545fb63d7187f59eb');
                    }}
                    enabled={treatmentsForVideo.includes(13)}
                    audioFile="/audio/spiekbrief/ei.mp3"
                    text={<p>ei</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('43c33b903d5558bdf61840a901359d48');
                    }}
                    enabled={treatmentsForVideo.includes(17)}
                    audioFile="/audio/spiekbrief/au.mp3"
                    text={<p>au</p>}
                />
            </CheatSheetBox>{' '}
            <CheatSheetBox text="Regelwoorden">
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('eec4d2d44322bcb950dc13ce072b174b');
                    }}
                    enabled={treatmentsForVideo.includes(11)}
                    audioFile="/audio/spiekbrief/t-of-d.mp3"
                    text={<p>-t of -d</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('db9bdbbfa28d2d7fa6a6fc0ef9b489b4');
                    }}
                    enabled={treatmentsForVideo.includes(19)}
                    audioFile="/audio/spiekbrief/f-of-s.mp3"
                    text={<p>-f -s</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('f8f7328534c331ea2410120e177a4d22');
                    }}
                    enabled={treatmentsForVideo.includes(21)}
                    audioFile="/audio/spiekbrief/g-of-ch.mp3"
                    text={<p>-g of -ch</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('786aef92ad98d2d22ac2fe3abe031865');
                    }}
                    enabled={treatmentsForVideo.includes(22)}
                    audioFile="/audio/spiekbrief/zo-ga-nu-mee.mp3"
                    text={<p>Zo ga nu mee</p>}
                />
            </CheatSheetBox>
            <CheatSheetBox text="Bijna wat ik hoor">
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('16f678194b0e8869d0497b0d1e311018');
                    }}
                    enabled={treatmentsForVideo.includes(12)}
                    audioFile="/audio/spiekbrief/eer-oor-eur.mp3"
                    text={<p>eer oor eur</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('a5dde2fb4b44eb7e1368f7da2463e4a7');
                    }}
                    enabled={treatmentsForVideo.includes(14)}
                    audioFile="/audio/spiekbrief/aai-ooi-oei.mp3"
                    text={<p>aai ooi oei</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('8e9c5f54bb27f292326eedb189b6f7bc');
                    }}
                    enabled={treatmentsForVideo.includes(15)}
                    audioFile="/audio/spiekbrief/eeuw-ieuw-uw.mp3"
                    text={<p>eeuw ieuw uw</p>}
                />
            </CheatSheetBox>
            <CheatSheetBox text="Wat ik hoor" />
        </>
    );
}
